module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e6f716edc49c30d8e46444093f2c113a.svg";